import { FormHelperText, Grid, Stack } from '@mui/material'
import { GContainer, GItem, GItemContainer, MiddleGItem } from '../components/common/grids'
import { SubTitle } from '../components/common/subTitle'
import { AttentionLabel } from '../components/common/attentionLabel'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { BackButton } from '../components/common/buttons/backButton'
import { Form } from '../components/common/inputs/form'
import { translate } from '../../i18n'
import { yesNo } from '../../containers/common/constant/classification'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { useAction } from '../../containers/memberModifyChildBirth/memberModifyChildBirthService'
import DecimalTypeField from '../components/common/member/decimalTypeField'
import { Control, useFormState } from 'react-hook-form'
import { NumberBox } from '../components/common/inputs/numberBox'
import { getValueByNameStr } from '../../utils/objectUtil'

export const MemberModifyChildBirth = () => {
  const { CATEGORY_KEYS, formMethods, categoryMst, onSubmit, childrenResultCode } = useAction()

  const categories = categoryMst
    ?.filter((mst) => CATEGORY_KEYS.includes(mst.category))
    .sort((a, b) => CATEGORY_KEYS.indexOf(a.category) - CATEGORY_KEYS.indexOf(b.category))

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {!!categories?.length ? (
                <>
                  <SubTitle title={'出生時情報'} />
                  {categories &&
                    categories.map((obj) => {
                      return <InputForm categoryMst={obj} control={formMethods.control} key={obj.category} />
                    })}
                </>
              ) : (
                <>{translate('memberModifyChildFamilyHospital.error.noCategoryMst')}</>
              )}
            </Stack>
          </Grid>
        </Grid>
        {!!childrenResultCode && (
          <ErrorMessageCard
            messages={[translate(`memberModifyChildFamilyHospital.error.childrenResultCode${childrenResultCode}`)]}
          />
        )}
        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('memberModifyChildFamilyHospital.button.decision')}
          </ButtonOutlinedWarningL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}

interface InputFormProps {
  categoryMst: GetCategoryMstDto
  control: Control<any, any>
  facilitiesTypeList?: { value: string; label: string }[]
}

/** 各項目の入力フォーム */
const InputForm = (props: InputFormProps) => {
  const { categoryMst, control } = props
  const category = categoryMst.category

  const { errors } = useFormState({ control })
  const birthWeightError = getValueByNameStr(errors, 'birthWeight')

  if (category === 'birthHeight') {
    return (
      <GItemContainer xs={12} rowSpacing={1}>
        <MiddleGItem xs={5} sm={2}>
          {categoryMst.required === yesNo.yes && <AttentionLabel>*</AttentionLabel>}
          {categoryMst.altCategoryName ?? categoryMst.name}
        </MiddleGItem>
        <GItem xs={7} sm={10}>
          <DecimalTypeField
            name={'birthHeight'}
            label={categoryMst.altCategoryName ?? categoryMst.name}
            unit={'cm'}
            required={categoryMst.required === yesNo.yes}
            control={control}
            intMax={100}
            intMin={1}
            fracMax={99}
            fracMin={0}
          />
        </GItem>
      </GItemContainer>
    )
  } else if (category === 'birthWeight') {
    return (
      <GItemContainer xs={12} rowSpacing={1}>
        <MiddleGItem xs={5} sm={2}>
          {categoryMst.required === yesNo.yes && <AttentionLabel>*</AttentionLabel>}
          {categoryMst.altCategoryName ?? categoryMst.name}
        </MiddleGItem>
        <GItem xs={7} sm={10}>
          <GContainer alignItems="flex-end">
            <GContainer alignItems="flex-end">
              <GItem xs="auto">
                <NumberBox
                  name={'birthWeight'}
                  label={categoryMst.altCategoryName ?? categoryMst.name}
                  max={9999}
                  min={1000}
                  placeholder={''}
                  control={control}
                  required={categoryMst.required === yesNo.yes}
                />
              </GItem>
              <GItem xs={0.1} style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
                {'g'}
              </GItem>
            </GContainer>
            <GContainer alignItems="flex-end">
              {birthWeightError && <FormHelperText error>{birthWeightError.message}</FormHelperText>}
            </GContainer>
          </GContainer>
        </GItem>
      </GItemContainer>
    )
  } else {
    return null
  }
}
